'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeProfileZoneFile = makeProfileZoneFile;
exports.getTokenFileUrl = getTokenFileUrl;

var _zoneFile = require('zone-file');

function makeProfileZoneFile(origin, tokenFileUrl) {
  if (tokenFileUrl.indexOf('://') < 0) {
    throw new Error('Invalid token file url');
  }

  var urlScheme = tokenFileUrl.split('://')[0];
  var urlParts = tokenFileUrl.split('://')[1].split('/');
  var domain = urlParts[0];
  var pathname = '/' + urlParts.slice(1).join('/');

  var zoneFile = {
    $origin: origin,
    $ttl: 3600,
    uri: [{
      name: '_http._tcp',
      priority: 10,
      weight: 1,
      target: urlScheme + '://' + domain + pathname
    }]
  };

  var zoneFileTemplate = '{$origin}\n{$ttl}\n{uri}\n';

  return (0, _zoneFile.makeZoneFile)(zoneFile, zoneFileTemplate);
}

function getTokenFileUrl(zoneFileJson) {
  if (!zoneFileJson.hasOwnProperty('uri')) {
    return null;
  }
  if (!Array.isArray(zoneFileJson.uri)) {
    return null;
  }
  if (zoneFileJson.uri.length < 1) {
    return null;
  }
  var firstUriRecord = zoneFileJson.uri[0];

  if (!firstUriRecord.hasOwnProperty('target')) {
    return null;
  }
  var tokenFileUrl = firstUriRecord.target;

  if (tokenFileUrl.startsWith('https')) {
    // pass
  } else if (tokenFileUrl.startsWith('http')) {
    // pass
  } else {
    tokenFileUrl = 'https://' + tokenFileUrl;
  }

  return tokenFileUrl;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/blockstack/lib/profiles/profileZoneFiles.js
// module id = 224
// module chunks = 0